var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex flex-wrap" }, [
    _c(
      "div",
      { staticClass: "w-full md:w-3/4 md:pr-20" },
      [
        _c("h1", { staticClass: "mt-2 mb-4 font-sans text-n-gray-dark" }, [
          _vm._v("Account Details"),
        ]),
        _vm._v(" "),
        _c("form", [
          _c("div", { staticClass: "mb-12" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'",
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.first_name,
                  expression: "form.first_name",
                },
              ],
              attrs: { id: "first_name", type: "text", name: "first_name" },
              domProps: { value: _vm.form.first_name },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form, "first_name", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("first_name"),
                    expression: "errors.has('first_name')",
                  },
                ],
                staticClass: "error text-error-red text-lg",
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.errors.first("first_name")) +
                    "\n        "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-12" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'",
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.last_name,
                  expression: "form.last_name",
                },
              ],
              attrs: { id: "last_name", type: "text", name: "last_name" },
              domProps: { value: _vm.form.last_name },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form, "last_name", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("last_name"),
                    expression: "errors.has('last_name')",
                  },
                ],
                staticClass: "error text-error-red text-lg",
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.errors.first("last_name")) +
                    "\n        "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-12" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|email",
                  expression: "'required|email'",
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.email,
                  expression: "form.email",
                },
              ],
              attrs: { id: "email", type: "email", name: "email" },
              domProps: { value: _vm.form.email },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form, "email", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("email"),
                    expression: "errors.has('email')",
                  },
                ],
                staticClass: "error text-error-red text-lg",
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.errors.first("email")) +
                    "\n        "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-12" }, [
            _vm._m(3),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.phone,
                  expression: "form.phone",
                },
              ],
              attrs: { id: "phone", type: "tel", name: "phone" },
              domProps: { value: _vm.form.phone },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form, "phone", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("phone"),
                    expression: "errors.has('phone')",
                  },
                ],
                staticClass: "error text-error-red text-lg",
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.errors.first("phone")) +
                    "\n        "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-12" }, [
            _vm._m(4),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "min:8|upperCase|number|lowerCase",
                  expression: "'min:8|upperCase|number|lowerCase'",
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.password,
                  expression: "form.password",
                },
              ],
              attrs: { id: "password", type: "password", name: "password" },
              domProps: { value: _vm.form.password },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form, "password", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("password"),
                    expression: "errors.has('password')",
                  },
                ],
                staticClass: "error text-error-red text-lg",
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.errors.first("password")) +
                    "\n        "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.validateUpdate.apply(null, arguments)
                },
              },
            },
            [_vm._v("\n        Update\n      ")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mb-12" }),
        _vm._v(" "),
        _c("OrganizationAdditionalInfo"),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "w-full md:w-1/4 md:pt-40" }, [
      _c(
        "div",
        { staticClass: "sidebar-block border-t-5 border-black pt-3" },
        [
          _c("public-profile-link"),
          _vm._v(" "),
          _c("h2", { staticClass: "text-lg mb-5 font-sans text-n-gray-dark" }, [
            _vm._v("Help with My Account"),
          ]),
          _vm._v(" "),
          _vm._m(5),
          _vm._v(" "),
          _c("support"),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "first_name" } }, [
      _vm._v("\n          First name "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "last_name" } }, [
      _vm._v("\n          Last name "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "email" } }, [
      _vm._v("\n          Email "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "email" } }, [
      _vm._v("\n          Phone\n          "),
      _c(
        "span",
        { staticClass: "block text-sm font-sans-book text-n-gray-dark" },
        [
          _vm._v(
            "\n            Optional, in case we need to contact you\n          "
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "password" } }, [
      _vm._v("\n          Change Password\n          "),
      _c("span", { staticClass: "block text-sm" }, [
        _vm._v(
          "\n            Password should contain at least 8 characters, including at least 1 lowercase letter, 1 uppercase letter, and 1 number.\n          "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "list-reset mb-10 text-base" }, [
      _c("li", { staticClass: "mb-2" }, [
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href: "https://help.letsreimagine.org/hc/en-us/sections/360008463452-Creating-your-account-and-public-profile",
            },
          },
          [_vm._v("\n            Profile and Account Guide\n          ")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }